import { MediaDeviceFailure } from 'livekit-client'

export type DeviceName = 'microphone' | 'camera'

export type DeviceWarningReason = 'blocked' | 'notFound' | 'inUse' | 'unknown'

export type DeviceWarningMessageKey = `chat.call.deviceWarning.${DeviceName}.${DeviceWarningReason}`

export type DeviceWarning = {
  reason: DeviceWarningReason
  messageKey: DeviceWarningMessageKey
  isBlocking: boolean
}

const messageKey = (device: DeviceName, reason: DeviceWarningReason): DeviceWarningMessageKey =>
  `chat.call.deviceWarning.${device}.${reason}`

const warning = (
  device: DeviceName,
  reason: DeviceWarningReason,
  isBlocking = false
): DeviceWarning => ({ reason, messageKey: messageKey(device, reason), isBlocking })

export const blockedWarning = (device: DeviceName): DeviceWarning => warning(device, 'blocked')

export function deviceWarning(device: DeviceName, error: unknown): DeviceWarning {
  switch (MediaDeviceFailure.getFailure(error)) {
    case MediaDeviceFailure.PermissionDenied:
      return warning(device, 'blocked')
    case MediaDeviceFailure.NotFound:
      return warning(device, 'notFound', true)
    case MediaDeviceFailure.DeviceInUse:
      return warning(device, 'inUse')
    default:
      return warning(device, 'unknown')
  }
}
